import React from 'react';

const Header = ({ quickLinks }) => {
  return (
    <header className='border-b border-gray-300 py-5 px-4 md:px-0'>
      <div className='container mx-auto flex justify-between items-end md:px-5'>
        <div className='flex'>
          <div className='border-r border-nusblue pr-4'>
            <img
              src='https://bschool.nus.edu.sg/L3/images/logo.png'
              alt=''
              className='h-8 md:h-16'
            />
          </div>
          <div className='pl-2'>
            <a href='https://bschool.nus.edu.sg'>
              <img
                src='https://bschool.nus.edu.sg/L3/images/sublogo.png'
                alt='Nus Business School'
                className='h-8 md:h-16'
              />
            </a>
          </div>
        </div>
        <div>
          <ul className='hidden md:flex'>
            {quickLinks.map((nav, index) => (
              <li key={index}>
                <a className='ml-6 hover:text-orange-500' href={nav.url}>
                  {nav.title}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Header;
